<template>
  <Header title="Privacy Policy" />
  <Container>
    <h2>Privacy Policy</h2>
    <p>
      Please take a few minutes to read the following policy so that you understand how we treat your information. As we continuously improve and expand our services. We only use your location and data to send your position back to a GTSE or OpenGTS for tracking purposes.<br/><br/>By purchasing the app and using it you agree to these policies. We do not take personal information unless you are asked for it to add your app to the server platform for tracking purposes. This app needs to have an account on said GTSE or OpenGTS server to function. If you have questions or comments about our privacy policy please <a class="text-accent underline hover:no-underline" href="/contact">contact us</a>.
    </p>
  </Container>
</template>

<script>
import Container from "@/components/base/Container";
import Header from "@/components/base/Header";

export default {
  components: {
    Container,
    Header,
  },
};
</script>
